module.exports = __webpack_public_path__ + "static/media/cloud-phonecall-man.17610a43.png";